export default __webpack_public_path__ + "static/media/award2.e3471b26.svg";